import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { SMALL_VIEWPORT_MAX_WIDTH } from "config/constants";

const MobileMenuContext = createContext(
  {} as { isMobileMenuOpen: boolean; toggleMobileMenu: () => void }
);
const useMobileMenu = () => useContext(MobileMenuContext);
const { Provider } = MobileMenuContext;

const MobileMenuProvider = (props: { children: ReactNode | undefined }) => {
  const { children } = props;

  // Closed until the burger icon opens it, the website's navigation would cover the top of the map
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = useCallback(() => {
    setMobileMenuOpen((value: boolean) => !value);
  }, [setMobileMenuOpen]);

  const autoHideMobileMenu = useCallback(() => {
    if (window.innerWidth > SMALL_VIEWPORT_MAX_WIDTH) {
      setMobileMenuOpen(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", autoHideMobileMenu);

    return () => {
      window.removeEventListener("resize", autoHideMobileMenu);
    };
  }, [autoHideMobileMenu]);

  return (
    <Provider value={{ isMobileMenuOpen, toggleMobileMenu }}>
      {children}
    </Provider>
  );
};

export { MobileMenuProvider, useMobileMenu };
